import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "mizukara-lang";

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved === "jp" ? "jp" : "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* storage unavailable */
    }
    document.documentElement.lang = lang === "jp" ? "ja" : "en";
  }, [lang]);

  // dot-path lookup: t("nav.home")
  const t = useCallback(
    (path) => {
      const dict = translations[lang] || translations.en;
      const value = path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), dict);
      if (value === undefined) {
        const fallback = path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), translations.en);
        return fallback !== undefined ? fallback : path;
      }
      return value;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
}
